import { useLocation } from "@builder.io/qwik-city";
import {
  Slot,
  isServer,
  useTask$,
  useSignal,
  component$,
} from "@builder.io/qwik";

export const PageTransition = component$(() => {
  const location = useLocation();
  const prevStep = useSignal<number | null>(null);
  const direction = useSignal<"forward" | "backward">("forward");
  const transitionCounter = useSignal(0);

  useTask$(({ track }) => {
    track(() => location.url.pathname);

    if (isServer) return;

    const match = location.url.pathname.match(/\/steps\/(\d+)\/?/);
    const currentStep = match ? parseInt(match[1], 10) : null;

    if (currentStep !== null && prevStep.value !== null) {
      transitionCounter.value++;

      const historyState = window.history.state;
      if (historyState?.direction) {
        direction.value =
          historyState.direction === "forward" ? "forward" : "backward";
      } else {
        if (currentStep > prevStep.value) {
          direction.value = "forward";
        } else {
          direction.value = "backward";
        }
      }
    }

    prevStep.value = currentStep;
  });

  return (
    <div
      key={transitionCounter.value}
      class={`x-transition-${direction.value}-in`}
    >
      <Slot />
    </div>
  );
});
